import { subDays } from 'date-fns';

import { ObjectDateTransformer } from '../../coaching-insight.model';
import { periodTypeDays } from '../const/period-type-days.const';
import { InsightsSummaryDataKpi } from '../model/insights-summary-data-kpi.model';
import { InsightsSummaryDataPeriodTypes } from '../model/insights-summary-data-period-types.model';
import { InsightsSummaryData } from '../model/insights-summary-data.model';
import { KpiType } from '../model/kpi-type.model';
import { ViewSummaryPeriodType } from '../model/view-summary-period-type.model';

import { checkKpiFormat } from './check-kpi-format.function';
import { defaultSummaryKpi } from './default-summary-kpi.function';
import { defaultViewSummaryPeriodType } from './default-view-summary-period-type.function';

export function checkInsightSummaryData(opts: {
    insightSummaryData: InsightsSummaryData;
    periodTypeId: number;
    periodDate: Date;
    kpiTypeId: KpiType;
}): {
    kpis: InsightsSummaryDataKpi[];
    periodTypes: ViewSummaryPeriodType[];
    selectedPeriodType: InsightsSummaryDataPeriodTypes;
    selectedKpi: InsightsSummaryDataKpi;
} {
    const dateTransformer = new ObjectDateTransformer<InsightsSummaryData>({
        periodTypes: {
            periodTypeDate: 'L',
        },
    });

    const data = dateTransformer.transform(opts.insightSummaryData) ?? {};

    data.periodTypes = data.periodTypes ?? [];
    const periodTypes: ViewSummaryPeriodType[] =
        data.periodTypes?.map<ViewSummaryPeriodType>((e) => {
            return {
                ...e,
                periodTypeId: e.periodTypeId,
                startDate: subDays(
                    e.periodTypeDate,
                    e.periodTypeId in periodTypeDays
                        ? periodTypeDays[e.periodTypeId]
                        : 0,
                ),
                endDate: new Date(e.periodTypeDate),
                isDefault: e.isDefault,
            };
        });
    if (periodTypes.length === 0) {
        periodTypes.push(defaultViewSummaryPeriodType());
    }

    data.kpis = data.kpis ?? [];
    const kpis: InsightsSummaryDataKpi[] = [...data.kpis].sort(
        (a, b) => a.displayOrder - b.displayOrder,
    );
    kpis.forEach((e) => {
        if (e.kpiTypeId === KpiType.FL_WINNING_PERCENTAGE) {
            e.kpiTypeId = KpiType.WINNING_PERCENTAGE;
        }
    });
    if (kpis.length === 0) {
        kpis.push(defaultSummaryKpi());
    }

    const selectedPeriodType =
        periodTypes.find(
            (e) =>
                e.periodTypeId === opts.periodTypeId &&
                e.endDate.getTime() === opts.periodDate.getTime(),
        ) ??
        periodTypes.find((e) => e.isDefault) ??
        periodTypes?.[0];

    const selectedKpi =
        kpis.find((e) => e.kpiTypeId === opts.kpiTypeId) ??
        kpis.find((e) => e.isDefault) ??
        kpis?.[0];

    checkKpiFormat(data.kpis);

    return { kpis, periodTypes, selectedPeriodType, selectedKpi };
}
